module.exports = __webpack_public_path__ + "img/question.683d538e.png";